import { Col, Row } from "react-bootstrap";
import NormativityPercentByYearsGraph from "../../../widgets/analytics/overallAnalytics/graphs/NormativityPercentByYearsGraph";
import RoadAccidentsNumberByYearsGraph from "../../../widgets/analytics/overallAnalytics/graphs/RoadAccidentsNumberByYearsGraph";
import RoadsLengthByBedTypeGraph from "../../../widgets/analytics/overallAnalytics/graphs/RoadsLengthByBedTypeGraph";
import RoadsLengthByCategoryGraph from "../../../widgets/analytics/overallAnalytics/graphs/RoadsLengthByCategoryGraph";
import ObjectTypesInfoPanelContent from "../../../widgets/analytics/overallAnalytics/ObjectTypesInfoPanelContent";
import OverallAnalyticsPanel from "../../../widgets/analytics/overallAnalytics/OverallAnalyticsPanel";
import RoadsNumberAndLengthInfo from "../../../widgets/analytics/overallAnalytics/RoadsNumberAndLengthInfo";
import ContentHeader from "../../../widgets/contentHeader/ContentHeader";

export default function OverallAnalyticsPage() {
    return (
        <>
            <ContentHeader title="Общая аналитика" />
            <div className="overall-analytics-div">
                <p className="overall-analytics-header">Информация о&nbsp;дорогах</p>
                <RoadsNumberAndLengthInfo />
                <div className="overall-analytics-panels-div">
                    <Row className="overall-analytics-panels-row g-3" xs={1} md={2} xl={3}>
                        <Col>
                            <OverallAnalyticsPanel headerTitle="Протяжённость автомобильных дорог по&nbsp;категориям, км">
                                <RoadsLengthByCategoryGraph />
                            </OverallAnalyticsPanel>
                        </Col>
                        <Col>
                            <OverallAnalyticsPanel headerTitle="Протяжённость автомобильных дорог по&nbsp;типам дорожной одежды, км">
                                <RoadsLengthByBedTypeGraph />
                            </OverallAnalyticsPanel>
                        </Col>
                        <Col>
                            <OverallAnalyticsPanel headerTitle="Доля автомобильных дорог, соответствующих нормативным требованиям">
                                <NormativityPercentByYearsGraph />
                            </OverallAnalyticsPanel>
                        </Col>
                        <Col>
                            <OverallAnalyticsPanel headerTitle="Количество ДТП по годам">
                                <RoadAccidentsNumberByYearsGraph />
                            </OverallAnalyticsPanel>
                        </Col>
                        <Col>
                            <OverallAnalyticsPanel headerTitle="Искусственные дорожные сооружения">
                                <ObjectTypesInfoPanelContent
                                    objectTypesNames={['RoadRiverBridges', 'RoadWaterPipes', 'RoadTunnels', 'RoadFerrys', 'Gallerys', 'RoadBreastWalls', 'RoadRailWayCrossings']}
                                />
                            </OverallAnalyticsPanel>
                        </Col>
                        <Col>
                            <OverallAnalyticsPanel headerTitle="Объекты дорожных служб">
                                <ObjectTypesInfoPanelContent
                                    objectTypesNames={['RoadPolicePosts', 'RoadControlPosts', 'RoadTollStations', 'RoadWeightControls']}
                                />
                            </OverallAnalyticsPanel>
                        </Col>
                        <Col>
                            <OverallAnalyticsPanel headerTitle="Инженерное обустройство">
                                <ObjectTypesInfoPanelContent
                                    objectTypesNames={['RoadSigns', 'RoadDistanceMarks', 'RoadFenceSegments', 'RoadCrosswalks']}
                                />
                            </OverallAnalyticsPanel>
                        </Col>
                        <Col>
                            <OverallAnalyticsPanel headerTitle="Объекты сервиса">
                                <ObjectTypesInfoPanelContent
                                    objectTypesNames={['RoadGasStations', 'RoadTechServiceStations', 'RoadWashingPoints', 'RoadParkings', 'RoadBusstops', 'RoadPublicCaterings', 'RoadToilets']}
                                />
                            </OverallAnalyticsPanel>
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    )
}
